<template>

  <div v-if="store.projects && store.selectedProject" class="relative">
    <button v-if="store.selectedProject" type="button" id="dropdownDefaultButton" data-dropdown-toggle="dropdownAcc"
            class="text-sm font-medium text-gray-700 dark:text-white inline-flex items-center focus:outline-none">
      {{ store.selectedProject.spaceName }}
      <svg class="w-2.5 h-2.5 ml-2.5 text-gray-800 dark:text-white" aria-hidden="true"
           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5 5 1 1 5m0 6 4 4 4-4"/>
      </svg>
      <span class="ml-2">/</span>
    </button>


    <button v-if="store.selectedProject" type="button" id="dropdownDefaultButton" data-dropdown-toggle="dropdownAcc"
            class="text-sm font-medium text-gray-700 dark:text-white inline-flex items-center focus:outline-none">
      <span class="ml-2">{{ store.selectedProject.name }}</span>
      <svg class="w-2.5 h-2.5 ml-2.5 text-gray-800 dark:text-white" aria-hidden="true"
           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5 5 1 1 5m0 6 4 4 4-4"/>
      </svg>

      <span class="ml-2">/</span>
    </button>

    <div v-if="store.spaces" id="dropdownAcc"
         class="left-0 customTranslate min-w-full z-10 w-auto hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 flex">
      <div class="border-r">
        <ul class="py-2 text-sm text-gray-700 dark:text-gray-200 px-1"
            aria-labelledby="dropdownDefaultButton">
          <li class="text-center font-bold pb-2 mb-1 mt-1 border-b">Spaces</li>
          <li @mouseover="hoveredSpace = space.spaceId" v-for="(space, spaceIndex) in store.spaces">
            <a
                href="#"
                class="block px-4 py-2 hover:bg-gray-100 rounded-xl dark:hover:bg-gray-600 dark:hover:text-white"
                :class="{ 'bg-gray-100 dark:bg-gray-600' : ( space.spaceId === hoveredSpace) }">
              <span class="block px-4 text-xs py-2 text-gray-600 dark:text-white whitespace-nowrap"> {{
                  space.spaceName
                }}</span>
            </a>

          </li>

        </ul>
      </div>
      <div class="w-full" style="border-top: 0px">

        <ul class="py-2 text-sm text-gray-700 dark:text-gray-200 px-1"
            aria-labelledby="dropdownDefaultButton">
          <li class="text-center font-bold pb-2 mb-1 mt-1 border-b">Projects</li>
          <li v-for="( project ) in projects.filter(p => p.spaceId === hoveredSpace)">
            <a v-on:click="changeProject(project)"
               href="#"
               :class="{ 'bg-gray-100 dark:bg-gray-600' : (store.selectedProject && project._id === store.selectedProject._id) }"
               class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-xl dark:hover:text-white">
              <span class="block px-4 text-xs py-2 text-gray-600 dark:text-white whitespace-nowrap flex">
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" class="mr-1 mt-1" fill="currentColor">
                  <path
                      d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"/></svg>
                {{
                  project.name
                }}</span>
            </a>

          </li>

        </ul>
      </div>

    </div>
    <span class="ml-2 font-medium text-sm dark:text-white">{{ getRout }}</span>

  </div>

  <dropdown v-if="projects && !store.selectedProject" placement="bottom" :text="header">
    <list-group class="overflow-y-auto" style="max-height: 400px">
      <div v-for="(space, accountIndex) in store.spaces">
                <span
                    class="inline-flex items-center w-full px-4 py-2 border-b border-gray-200 dark:border-gray-600 block text-xl"
                >
                    {{ space.spaceName }}
                </span>
        <list-group-item v-for="(project, projectIndex) in projects.filter(p => p.spaceId === space.spaceId)"
                         v-on:click="changeProject(project)">
                    <span
                        class="inline-flex items-center w-full px-4 py-2 block"
                    >- {{ project.name }}</span>
        </list-group-item>
      </div>
    </list-group>
  </dropdown>
</template>
<script setup>
import {Dropdown, ListGroup, ListGroupItem} from "flowbite-vue";
</script>
<script>
import {Dropdown as DropdownClassic, initFlowbite} from "flowbite";
import {useAppStore} from "@/stores/appStore"

export default {
  name: "websiteSelect",
  data() {
    const store = useAppStore();
    return {
      // accounts: store.accounts,
      header: "",
      store: store,
      dropdown: null,
      hoveredSpace: store.selectedProject?.spaceId || store.projects[0].spaceId,
    };
  },
  mounted() {
    this.setHeader();
    initFlowbite();
  },
  methods: {
    setHeader() {
      if (this.store.selectedProject != null) {
        this.header = this.store.selectedProject.name;
      } else {
        this.header = "Vyberte projekt";
      }
    },
    async changeProject(project) {

      this.closeDropdown();

      //změna projektu
      this.store.selectedProject = project;

      //přesměrování na stránku pages
      await this.$router.push('/' +
          this.store.toUrl(this.store.selectedProject.spaceName) + '/' +
          this.store.toUrl(this.store.selectedProject.name) +
          "/admin"
      );
      // Obnovení stránky
      await this.$nextTick(() => {
        location.reload();
      });
    },
    changeAccount(space) {
      this.closeDropdown()
      this.store.selectedProject = null;
      this.store.selectedSpace = space;


      this.$router.push(
          "/" + this.store.toUrl(this.store.selectedProject.spaceName) + '/projects'
      );

    },
    closeDropdown() {
      if (this.store.selectedAccount) {
        const $dropdownMenu = document.getElementById('dropdownAcc');
        const $dropdownButton = document.getElementById('dropdownDefaultButton');

        const options = {
          placement: 'bottom',
          triggerType: 'click',
          offsetSkidding: 0,
          offsetDistance: 10,
          delay: 300,
        };
        const dropdown = new DropdownClassic($dropdownMenu, $dropdownButton, options);
        dropdown.hide();
      }
    }
  },
  computed: {
    projects() {
      return this.store.projects;
    },
    getRout() {
      return this.$route.name;
    }
  }, created() {

  },
};
</script>

<style scoped>
.customTranslate {
  transform: translate(0px, 33px) !important;
}
</style>
